import { render } from "./ChannelActions.vue?vue&type=template&id=6f6a95b1&lang=pug"
import script from "./ChannelActions.js?vue&type=script&scoped=true&lang=js&external"
export * from "./ChannelActions.js?vue&type=script&scoped=true&lang=js&external"

import "./ChannelActions.vue?vue&type=style&index=0&id=6f6a95b1&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__